"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortsSearchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const TextInput_1 = require("../../../generic/TextInput");
const common_styled_components_1 = require("../../../common-styled-components");
const theme_1 = require("../../../../theme");
const PortsSearchInput = ({ query, onQueryChange, ports, loading, error, title, }) => {
    const trimmed = query.trim();
    const isNumeric = /^\d+$/.test(trimmed);
    const canSearch = trimmed.length >= 3 || isNumeric;
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [title && (0, jsx_runtime_1.jsx)(Title, { as: common_styled_components_1.SmallSubtitle, children: title }), (0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { value: query, onChange: onQueryChange, placeholder: "Search\u2026" }), (0, jsx_runtime_1.jsxs)(Body, { children: [!canSearch ? ((0, jsx_runtime_1.jsx)(HelperText, { children: "Enter at least 3 characters, or a numeric ID, to search." })) : null, error && (0, jsx_runtime_1.jsx)(ErrorText, { children: error }), canSearch ? (
                    // Show Searching… while request is being prepared (debounce) or in-flight
                    loading || ports === undefined ? ((0, jsx_runtime_1.jsx)(StatusText, { children: "Searching\u2026" })) : ports && ports.length > 0 ? ((0, jsx_runtime_1.jsx)("div", {}) // Results are shown in parent component
                    ) : ((0, jsx_runtime_1.jsx)(StatusText, { children: "No results" }))) : null] })] }));
};
exports.PortsSearchInput = PortsSearchInput;
exports.default = exports.PortsSearchInput;
const Container = styled_components_1.default.div `
  margin-bottom: ${theme_1.theme.spacing(2)};
`;
const Title = styled_components_1.default.div `
  margin-bottom: ${theme_1.theme.spacing(1)};
`;
const Body = styled_components_1.default.div `
  margin-top: ${theme_1.theme.spacing(2)};
  font-size: ${theme_1.theme.fontSize(-1)};
`;
const HelperText = styled_components_1.default.div `
  color: ${theme_1.theme.colors.grey(7)};
`;
const ErrorText = styled_components_1.default.div `
  color: ${theme_1.theme.colors.red ?? "#b00020"};
  margin-top: ${theme_1.theme.spacing(1)};
`;
const StatusText = styled_components_1.default.div `
  color: ${theme_1.theme.colors.blackText};
`;
